export enum GsErrorCode {
  UserAccountFrozenException = 4452,
  StripeInsufficientFundsOnPaymentMethod = 4456,
  DeclinedPaymentMethod = 4457,
  CreditCardDeclined = 4460,
  TypeOfPurchaseNotSupported = 4005,
  TeenAlreadyHasAParentException = 4489,
  IDologySSNNotReturnedException = 4493,
  SynapseBankAccountNumberInvalidException = 4494,
  SynapseBankRoutingNumberInvalidException = 4495,
  AllowancePeriodNotPendingForSubmitException = 4453,
  AllowancePeriodNotApprovedException = 4454,
  GalileoKYCFailedException = 4503,
  IDologyKYCFailedException = 4480,
  GalileoKYCInReviewException = 4481,
  SynapseKYCFailedException = 4501,
  UserWithErrorWhenDoingKYCException = 4502,
  DOBisRequiredToClaimGoalcardFromLockedGoalException = 4441,
  AffiliateContactNotFoundException = 4410,
  AffiliateContactCodeAlreadyUsedOrInvalidException = 4411,
  AffiliateNotFoundException = 4412,
  // not used
  // AffiliateGoalcardCannotBeAssociatedToParentException = 4440,
  // GoalLockedCannotBeUsedException = 4442,
  // GoalLockedCannotBeUnlockedYetException = 4443,
  // GoalLockedCannotBeDeletedException = 4444,
  // PaymentMethodNotFoundException = 4488,
  // PaymentNodeNotPaymentMethodException = 4508,
  // GalileoAccountWithInvalidNameOrLastName = 4479,
  // StripeDeclinedException = 4460
  GoalParentLockException = 4491,
  KidAlreadyHasParentException = 4492,
  PasswordInBlackList = 4053,
  IDologyKYCFailedWithRetryException = 4482,
  SynapseKYCInReviewException = 4483,
  GalileoAccountDuplicatedException = 4484,
  GalileoAccountWithInvalidAddress = 4485,
  StripeInvalidUsAddressCodeException = 4485,
  InvalidUsAddressException = 4485,
  GalileoAccountWithInvalidSSN = 4486,
  StripeInvalidSSNException = 4486,
  StripeInvalidUsZipCodeException = 4487,
  InvalidMobilePhoneNumberException = 4455,
  StripeInvalidTelephoneException = 4455,
  PasswordMinimumRequirementsNotMet = 4035,
  CreateAccountMissingAddress = 1324,
  CreateAccountMissingDateBirth = 4518,
  CreateAccountMissingCity = 4519,
  CreateAccountMissingLine1 = 4520,
  CreateAccountMissingState = 4521,
  CreateAccountMissingZIP = 4522,
  CreateAccountAffiliateCodeExpired = 4528,
  AffiliateNotFound = 1320,
  AffiliateContractNotStarted = 4037,
  AffiliateProgramCodeLimitReached = 4106,
  ReplaceCardFailed = 4543,
  ReplaceCardOkRequestFailed = 4544,
  ReplacedCardOkDBFailed = 4546,
  RestrictedWLSendMoneyFailed = 4556,
  // API General Errors
  UNABLE_TO_UPGRADE = 4026,
  UNABLE_TO_DOWNGRADE = 4027,
  CUSTOMER_USED_CODE_ERROR = 4066,
  ASSOCIATION_CHILD_LIMIT_REACHED = 4090,

  ALREADY_INVITED = 4925,
  ALREADY_INVITED_TIME = 4926,
  ALREADY_INVITED_TRY = 4927,
}

export enum GsStripeErrorCode {
  BALANCE_INSUFFICIENT = 'balance-insufficient',
  AUTHENTICATION_FAILURE = 'payment-intent-authentication-failure',
  UNSUPPORTED_TYPE = 'payment-method-unsupported-type',
}
